import { Injectable, computed, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { HorizonScan } from '../models';
import { AdminScanService } from '../services';

@Injectable()
export class HorizonScanStore {
  private readonly adminScanService = inject(AdminScanService);

  readonly scans = signal<HorizonScan[]>([]);
  readonly isLoading = signal(false);

  readonly internalScans = computed(() =>
    this.scans()
      .filter((scan) => scan.opType === 'NodeZero')
      .sort((a, b) => new Date(b.completedAt ?? 0).getTime() - new Date(a.completedAt ?? 0).getTime()),
  );

  readonly externalScans = computed(() =>
    this.scans()
      .filter((scan) => scan.opType === 'ExternalAttack')
      .sort((a, b) => new Date(b.completedAt ?? 0).getTime() - new Date(a.completedAt ?? 0).getTime()),
  );

  loadScans(apiKey: string, companyName: string) {
    this.isLoading.set(true);

    return this.adminScanService.getHorizonScans(apiKey, companyName).pipe(
      finalize(() => {
        this.isLoading.set(false);
      }),
    );
  }

  setScans(scans: HorizonScan[]) {
    this.scans.set(scans);
  }

  clear() {
    this.scans.set([]);
  }
}
